import { useState } from 'react';

type DateSetter = React.Dispatch<React.SetStateAction<Date | null>>;

interface UseDateState {
  date: Date | null;
  setDate: (dates: Date[] | Date | null) => void;
}

const useDateState = (initialDate: Date | null): UseDateState => {
  const [date, setDate] = useState<Date | null>(initialDate);

  const handleDateChange = (
    dates: Date[] | Date | null,
    setDateFn: DateSetter
  ) => {
    if (dates instanceof Date) {
      setDateFn(dates);
    } else if (Array.isArray(dates) && dates.length > 0) {
      setDateFn(dates[0]);
    } else {
      setDateFn(null);
    }
  };

  return { date, setDate: dates => handleDateChange(dates, setDate) };
};

export default useDateState;
